import HelpComponet from './HelpComponent.vue';

export const helpRoutes = {
  path: '/help',
  name: 'Help',
  component: HelpComponet,
  meta: {
    title: 'nav_bar.help',
    requireAuth: false
  }
};
